import { Box } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import EmailConfiguratorIframe from './EmailConfiguratorIframe';

import * as styles from './EmailConfigurator.css';

function EmailConfiguratorContent(): JSX.Element {
  return (
    <Box className={styles.root}>
      <EmailConfiguratorIframe />
    </Box>
  );
}

export default EmailConfiguratorContent;
